<script>
import {beforeUpdate,onMount} from 'svelte'
import Header from './components/header.svelte'
import ChartList from './components/chartList.svelte'
import ChartPanel from './components/chartPanel.svelte'
import db from './db'
import state from './states'
let {chart} = state
$: hasUser = 0
let pin
let error = false
let authenticated = state.authenticated

const createUser = async() =>{
let res = await db.users.add({
	name:'root',
	pin:pin
})

if(res){
	hasUser=1
}
}

const login = async ()=>{
db.users
			.where({name:'root', pin:pin})
			.first(user => {
				if(user){
					 authenticated.set(true)
					 localStorage.setItem('authenticated',true)
				}else{
					 authenticated.set(false)
					 error =true
				}
			  
			})
			.catch(error => {
console.error(error.stack || error);
});
						
}

beforeUpdate(async ()=>{
	hasUser  = await db.users.count()

	if (localStorage.authenticated === 'true'){
		authenticated.set(true)
	} 
})

</script>

{#if $authenticated === false}
<div class="flex bg-gray-800 h-screen w-screen">
	<div class="mx-auto h-full">
		<div class="flex content-center flex-wrap h-full">
				<div class="h-64 w-64">
					<img src="escape_logo.png" alt="^escape" />
					<div class="mt-10">
						<div class="capitalize text-gray-400 inline-block">PIN</div>
						<input bind:value={pin} class="" type="password" on:input={()=>{error=false}}/>
						{#if hasUser}
						<button class="m-2	w-full bg-teal-400 border-none rounded-full text-blue-900" type="button" on:click={login}>ESCAPE!</button>
						{:else}
						<button class="m-2	w-full bg-teal-400 border-none rounded-full text-blue-900"type="button" on:click={createUser}>CREATE ESCAPE POD!</button>
						{/if}
						{#if error}
						<div class="bg-red-200 text-red-700 text-center rounded-lg">
								Invalid PIN
						</div>
						{/if}
					</div>
				</div>
		</div>
	</div>
	</div>
	{:else}
	<div>
		<Header/>
		<div class=" w-full">
		{#if $chart}
		<ChartPanel/>
		{:else}
			<ChartList/>
			{/if}
		</div>
	</div>
		
	{/if}
